import React from 'react'

const Solutions = () => {
    return (
        <div>
            solutions routing test
        </div>
    )
}

export default Solutions
